import bankidMessages from '../messages/bankid.json';
import type { useTranslations } from 'next-intl';

type TFunction = ReturnType<typeof useTranslations<'bankid'>>;
export type BankidTranslationKey = Parameters<TFunction>[0];

// Type guard for userMessage keys
export type BankidUserMessageKey = keyof typeof bankidMessages.userMessage;
export const isValidBankidUserMessageKey = (key: string): key is BankidUserMessageKey => {
  return key in bankidMessages.userMessage;
};

// Helper to get userMessage translation key
export const getBankidUserMessageKey = (key: string): BankidTranslationKey | null => {
  if (isValidBankidUserMessageKey(key)) {
    return `userMessage.${key}`;
  }
  return null;
};
